/**
 * Firebase app initialization only. Do not import apiSlice, store, or FirebaseContext here.
 * This file exists to break the circular dependency: apiSlice → FirebaseContext → apiSlice.
 */
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { CheckLocalDev, FIREBASE_API } from '../config-global';

const connectToEmulatorInDev = CheckLocalDev() && process.env.REACT_APP_ENABLE_EMULATOR === 'true';

const firebaseApp = initializeApp(FIREBASE_API);

export const AUTH = getAuth(firebaseApp);
export const DB = getFirestore(firebaseApp);
export const CLOUD_FUNCTIONS = getFunctions(firebaseApp);

if (connectToEmulatorInDev) {
  const urlBase = 'localhost';
  const authPort = 3003;
  const firestorePort = 3002;
  const functionsPort = 3000;

  connectAuthEmulator(AUTH, `http://${urlBase}:${authPort}`);
  connectFirestoreEmulator(DB, urlBase, firestorePort);
  connectFunctionsEmulator(CLOUD_FUNCTIONS, urlBase, functionsPort);
}
